import BackIcon from "../../Assets/Icons/BackIcon";
import "./style.css";
import golf_image1 from "../../Assets/Images/golf_image1.png";
import golf_image2 from "../../Assets/Images/golf_image2.png";
import golf_image3 from "../../Assets/Images/golf_image3.png";
import golf_image4 from "../../Assets/Images/golf-pic4.png";
// import golf_image4 from "../../Assets/Images/ASP-sm.png";
import Golf4 from "../../Assets/Images/new/g11.png";
import Golf5 from "../../Assets/Images/Golf5.png";
import Golf6 from "../../Assets/Images/Golf6.png";
import Golf7 from "../../Assets/Images/new/g12.png";
import Golf8 from "../../Assets/Images/Golf8.png";
import Testimonial from "../../Components/Testimonial";
import Icon1 from "../../Assets/Icons/PCIcon";
import Icon2 from "../../Assets/Icons/FGSIcon";
import Icon3 from "../../Assets/Icons/TNFIcon";
import { useNavigate } from "react-router-dom";
import SEO from "../../Components/SEO";

export default function Golf() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const handleSubmit = (type) => {
    if (user && user.is_self_pay === false && type) {
      navigate(`/list-of-sports?type=${type}`);
    } else if (user && user.is_self_pay === true && type) {
      navigate(`/session-sports?type=${type}`);
    } else {
      navigate(`/create-an-account`);
    }
  };
  return (
    <>
      <SEO
        title="Instruction | Golf | BWC Sports"
        description=""
        url="https://bwcsports.com/instruction/golf"
      />
      <div className="golf-container">
        <div className="golf-header filter-brightness">
          <div className="base-sec">
            <div>
              <span className="golf-backIcon">
                <BackIcon />
              </span>
            </div>
            <div className="golf-header-content">
              <h1 className="black-text-clip">Golf</h1>
              <h3 className="black-text-clip">
                Swing into Success with Marseille Golf, Powered by BWC Sports!
              </h3>
              <p className="black-text-clip">
                Get Ready to Tee Off with Staten Island’s Most Exciting Golf
                Program
              </p>
              <p className="black-text-clip" style={{ fontWeight: "500" }}>
                Whether you’re a seasoned pro or picking up a club for the first
                time, there’s always room to perfect your swing. That’s
                why Marseille Golf and BWC Sports have teamed up to bring you a
                golf experience that’s as fun as it is challenging. It’s time to
                elevate your game and have a blast doing it!
              </p>
            </div>
          </div>
        </div>
        <div className="golf-booking-container">
          <button
            className="one-on-one"
            onClick={() => handleSubmit("1-1")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule for Classes Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one golf-booking-selected"
              onClick={() => handleSubmit("")}
              style={{ cursor: "pointer" }}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>
        <div className="golf-image-container">
          <img src={golf_image1} alt="soccer-image" />
          <img src={golf_image2} alt="soccer-image" />
          <img src={golf_image3} alt="soccer-image" />
          <img src={golf_image4} alt="soccer-image" />
        </div>
        <div className="golf-section2">
          <h1>Programs That Fit You to a Tee</h1>
          <h3 className="black-text-clip">Why Golf with Us?</h3>
          <p className="black-text-clip">
            Golf isn’t just about sinking putts—it’s about enjoying the journey,
            one swing at a time. With Marseille Golf and BWC Sports, you’ll find
            a program that blends expert coaching, cutting-edge technology, and
            an atmosphere that makes every session something to look forward to.
          </p>
        </div>
        <div className="features-container">
          <div
            className="features-card"
            style={{ border: `2px solid #11C900` }}
          >
            <div
              className="features-icon"
              style={{ border: `2px solid #11C900` }}
            >
              {Icon1 && <Icon1 className="features-icon-tag" />}
            </div>
            <h2 style={{ color: `#11C900` }}>Personalized Coaching</h2>
            <p className="black-text-clip">
              Because your game is unique, and so is our approach.{" "}
            </p>
          </div>
          <div
            className="features-card"
            style={{ border: `2px solid #11C900` }}
          >
            <div
              className="features-icon"
              style={{ border: `2px solid #11C900` }}
            >
              {Icon2 && <Icon2 className="features-icon-tag" />}
            </div>
            <h2 style={{ color: `#11C900` }}>Fun Group Sessions</h2>
            <p className="black-text-clip">
              Learn and laugh with others who love the game as much as you do.
            </p>
          </div>
          <div
            className="features-card"
            style={{ border: `2px solid #11C900` }}
          >
            <div
              className="features-icon"
              style={{ border: `2px solid #11C900` }}
            >
              {Icon3 && <Icon3 className="features-icon-tag" />}
            </div>
            <h2 style={{ color: `#11C900` }}>Top Notch Facilities</h2>
            <p className="black-text-clip">
              Practice with the best equipment in a welcoming environment.
            </p>
          </div>
        </div>
        <div className="track-and-field-section3">
          <h3 className="black-text-clip">Programs That Make Champions</h3>
          <p className="black-text-clip">
            Whether you’re just getting started or fine-tuning your skills,
            we’ve got a program that fits your style:
          </p>
          <div className="soccer-section3-image-container">
            <div className="sc-card">
              <img src={Golf4} alt="GolfImgOne" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Driving</div>
                <div className="sc-card-desc">
                  Practice powerful and accurate tee shots to cover distance.
                  Focus on grip, stance, and swing mechanics.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={Golf5} alt="GolfImgTwo" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Iron Play</div>
                <div className="sc-card-desc">
                  Develop precision with mid-range shots using irons. Work on
                  ball striking, alignment, and control.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={Golf6} alt="GolfImgTwo" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Putting</div>
                <div className="sc-card-desc">
                  Hone your short game. Practice reading greens, controlling
                  distance, and maintaining a smooth stroke.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={Golf7} alt="GolfImgThree" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Chipping</div>
                <div className="sc-card-desc">
                  Improve your ability to make delicate, short-distance shots
                  around the green.
                </div>
              </div>
            </div>
            <div class="sc-card">
              <img src={Golf8} alt="GolfImgFour" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Bunker Play</div>
                <div className="sc-card-desc">
                  Master the art of escaping sand traps with confidence.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="testimonial-container">
          <h3 className="testimonial-header black-text-clip">
            Hear from Our Golfing Community
          </h3>
        </div>
        <Testimonial />
        <div className="golf-booking-container2">
          <div className="golf-booking-container-details">
            <h3 className="black-text-clip">Ready to Take Your Swing?</h3>
            <p className="black-text-clip">
              The greens are calling! Don’t wait—join our program and discover
              just how much fun golf can be. Slots are limited, so grab your
              spot now and start swinging with confidence!
            </p>
            <p className="black-text-clip">
              Sign Up Now – Let’s make your next round your best one yet.
            </p>
          </div>
          <div id="inside-booking-container" className="golf-booking-container">
            <button
              className="one-on-one"
              onClick={() => handleSubmit("1-1")}
              style={{ cursor: "pointer" }}
            >
              <span className="black-text-clip">Schedule Class Here</span>
            </button>
            {!user && (
              <button
                className="one-on-one golf-booking-selected"
                onClick={() => handleSubmit("")}
                style={{ cursor: "pointer" }}
              >
                Sign Up for Classes Here
              </button>
            )}
          </div>
        </div>
        <div className="golf-booking-container outside-booking-container">
          <button
            className="one-on-one"
            onClick={() => handleSubmit("1-1")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one"
            onClick={() => handleSubmit("Group")}
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule for Classes Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one golf-booking-selected"
              onClick={() => handleSubmit("")}
              style={{ cursor: "pointer" }}
            >
              Sign Up for Classes Here
            </button>
          )}
        </div>

        <div className="golf-section4" style={{ alignItems: "center" }}>
          <h3>The Power of Partnership</h3>
          <p className="black-text-clip">
            At Marseille Golf, we’re passionate about making golf accessible,
            enjoyable, and rewarding. By partnering with BWC Sports, we’re able
            to offer a program that’s second to none. Together, we’re not just
            teaching golf—we’re building a community of enthusiastic players who
            know how to have fun while getting better.
          </p>
        </div>
        <div className="golf-locations">
          <h3>Locations</h3>
          <div className="golf-location-container">
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3032.288499132894!2d-74.2398164!3d40.53521490000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b53f9530b093%3A0x923a08def777405b!2s120%20Androvette%20St%2C%20Staten%20Island%2C%20NY%2010309%2C%20USA!5e0!3m2!1sen!2sin!4v1773672553981!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="ss-card-description black-text-clip">
                <p>
                  <strong>JUMPSHOTZ</strong>, New York
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
